import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { PageNotFound } from './components/views/PageNotFound/PageNotFound';
import { ProtectedRoute } from './components/common/ProtectedRoute/ProtectedRoute';
import { Login } from './components/views/Login/Login';
import { DeleteAccount } from './components/views/DeleteAccount/DeleteAccount';
import { Analytics } from './components/views/Analytics/Analytics';
import { Giftcards } from './components/views/Giftcards/Giftcards';
import { GiftcardsCodes } from './components/views/GiftcardsCodes/GiftcardsCodes';
import { FleetRegister } from './components/views/FleetRegister/FleetRegister';
import { FleetDetail } from './components/views/FleetRegister/FleetDetail';
import { FleetLoadForm } from './components/views/FleetRegister/FleetLoadForm';
import { FleetLoadDetails } from './components/views/FleetRegister/FleetLoadDetails';
import { Landing } from './components/views/Landing/Landing';
import { LandingFree } from './components/views/LandingFree/LandingFree';
import { QRLanding } from './components/views/QRLanding/QRLanding';
import { RetailLanding } from './components/views/RetailLanding/RetailLanding';
import { LinkLanding } from './components/views/LinkLanding/LinkLanding';
import { Cashea } from './components/views/Cashea/Cashea';
import { AffiliationsDB } from './components/views/AffiliationsDB/AffiliationsDB';
import { PrimaryAsistenciaPlan } from './components/views/PrimaryAsistancePlan/PrimaryAsistenciaPlan';
import { PAPComissions } from './components/views/PrimaryAsistancePlan/PAPComissions';
import { PAPComissionsDetail } from './components/views/PrimaryAsistancePlan/PAPComissionsDetail';
import { PotentialClients } from './components/views/PotentialClients/PotentialClients';
import { RenewalDB } from './components/views/AffiliationsDB/RenewalDB';
import { MultipleRenewal } from './components/views/AffiliationsDB/MultipleRenewal';
import { Order } from './components/views/AffiliationsDB/Order/Order';
import { PAPOrder } from './components/views/PrimaryAsistancePlan/PAPOrder';
import { UpgradeOrder } from './components/views/AffiliationsDB/Order/UpgradeOrder';
import { PaymentSection } from './components/views/AffiliationsDB/Order/PaymentSection/PaymentSection';
import { ChangePayment } from './components/views/AffiliationsDB/Order/ChangePayment';
import { RCVInfo } from './components/views/AffiliationsDB/Order/RCVInfo';
import { OrderDetail } from './components/views/AffiliationsDB/Order/OrderDetail';
import { PAPDetails } from './components/views/PrimaryAsistancePlan/PAPDetails';
import { SalesUsers } from './components/views/SalesUsers/SalesUsers';
import { RateDate } from './components/views/RateDate/RateDate';
import { Parameters } from './components/views/Parameters/Parameters';
import { UpdateHistory } from './components/views/UpdateHistory/UpdateHistory';
import { DiscountCode } from './components/views/DiscountCode/DiscountCode';
import { Exportables } from './components/views/Exportables/Exportables';
import { Inbox } from './components/views/Inbox/Inbox';
import { Comissions } from './components/views/Comissions/Comissions';
import { IntermediaryComissions } from './components/views/IntermediaryComissions/IntermediaryComissions';
import 'react-toastify/dist/ReactToastify.css';
import { salesRoles } from './assets/helpers/roles';
import './App.scss';
import { ValidatePayments } from './components/views/ValidatePayments/ValidatePayments';
import { CasheaLinkDeletedOrders } from './components/views/CasheaLinkDeletedOrders/CasheaLinkDeletedOrders';
import { Changes } from './components/views/Changes/Changes';
import { Goals } from './components/views/Goals/Goals';
import CasheaRedirect from './components/views/Landing/CasheaPopup/CasheaRedirect';
import CasheaCheckout from './components/views/Landing/CasheaPopup/CasheaCheckout';
import { RCVPrintablePage } from './components/views/RCV/RCVPrintablePage';
import { AdvancedPayments } from './components/views/AdvancedPayments/AdvancedPayments';
import { FloatingCalculadoraBCV } from './components/common/CalculadoraBCV/FloatingCalculadoraBCV';
import { FloatingCotizadorPlanes } from './components/common/CotizadorPlanes/FloatingCotizadorPlanes';
import auth from './services/authService';
import { EnvBanner } from './components/common/EnvBanner/EnvBanner';

function App() {
  const {
    SALES_DEVELOPER,
    SALES_ADMIN,
    SALES_SUPERVISOR,
    SALES_HUNTER,
    EVENTS,
    SALES_FARMER,
    SALES_COUNTER,
    SALES_MARKETING,
    SALES_ADMIN_AUX,
    RCV,
    SALES_RCV_SCORP,
    SALES_KEY_ACCOUNTS,
  } = salesRoles;

  const isLoggedIn = !!auth.getToken();

  const location = useLocation();
  const PUBLIC_PATHS = ["/login", '/cashea-confirmation'];
  const isPublicView =
    location.pathname === "/" ||
    PUBLIC_PATHS.some((path) => location.pathname.startsWith(path));

  return (
    <React.Fragment>
      <EnvBanner />
      <div className="app-content">
        <div>
          <Switch>
            <Route
              path="/login"
              render={(props) => {
                return <Login {...props} props={props} />;
              }}
            />
            <Route
              path="/delete-account"
              render={(props) => {
                return <DeleteAccount {...props} props={props} />;
              }}
            />
            <Route
              path="/rcv-print/:membershipId"
              render={(props) => {
                return <RCVPrintablePage {...props} props={props} />;
              }}
            />
            {/* Modulo de Analiticas */}
            <Route
              path="/landing/:saleChannel"
              render={(props) => {
                return <Landing {...props} props={props} />;
              }}
            />
            <Route
              path="/affiliation/:linkToken"
              render={(props) => {
                return <LinkLanding {...props} props={props} />;
              }}
            />
            <Route
              path="/affiliation-plan/apply-codes"
              render={(props) => {
                return <LandingFree {...props} props={props} />;
              }}
            />
            <Route
              path="/affiliation-link/:affiliationType/:linkToken/:saleChannel"
              render={(props) => {
                return <QRLanding {...props} affiliation-link props={props} />;
              }}
            />
            <Route
              path="/retail/:saleChannel"
              render={(props) => {
                return (
                  <RetailLanding {...props} affiliation-link props={props} />
                );
              }}
            />
            <ProtectedRoute
              path="/afiliations/status/:statusName/:statusId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_ADMIN_AUX,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={AffiliationsDB}
            />
            <ProtectedRoute
              path="/dashboard/afiliations/renewal/:statusId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={RenewalDB}
            />
            <ProtectedRoute
              path="/dashboard/pap-affiliated/commissions/details/:month?/:year?/:saleChannel?"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_ADMIN_AUX,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                SALES_FARMER,
                SALES_COUNTER,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PAPComissionsDetail}
            />
            <ProtectedRoute
              path="/dashboard/pap-affiliated/commissions"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_ADMIN_AUX,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                SALES_FARMER,
                SALES_COUNTER,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PAPComissions}
            />
            <ProtectedRoute
              path="/dashboard/pap-affiliated/:month?/:year?/:saleChannelId?"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_ADMIN_AUX,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PrimaryAsistenciaPlan}
            />
            <ProtectedRoute
              path="/dashboard/afiliations/multiple-renewal/:statusId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                SALES_FARMER,
                SALES_COUNTER,
                EVENTS,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={MultipleRenewal}
            />
            <ProtectedRoute
              path="/afiliations/edit-order/:membershipId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_ADMIN_AUX,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={Order}
            />
            <ProtectedRoute
              path="/afiliations/edit-pap-order/:membershipId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_ADMIN_AUX,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PAPOrder}
            />
            <ProtectedRoute
              path="/afiliations/upgrade-order/:membershipId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={UpgradeOrder}
            />
            <ProtectedRoute
              path="/afiliations/payment/:membershipId/:transactionType?/:duePayment?"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PaymentSection}
            />
            <ProtectedRoute
              path="/module/:transactionType/:giftcardId?"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PaymentSection}
            />
            <ProtectedRoute
              path="/afiliations/change-payment/:membershipId/:paymentTypeURL"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={ChangePayment}
            />
            <ProtectedRoute
              path="/afiliations/rcv/:membershipId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={RCVInfo}
            />
            <ProtectedRoute
              path="/afiliations/order-details/:membershipId/vehicle/:vehicleId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_ADMIN_AUX,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={OrderDetail}
            />
            <ProtectedRoute
              path="/afiliations/old-memberships/client/:clientId"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_ADMIN_AUX,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PAPDetails}
            />
            {/* Dashboard*/}
            <ProtectedRoute
              path="/dashboard/analytics"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_ADMIN_AUX,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={Analytics}
            />
            <ProtectedRoute
              path="/dashboard/exportable"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_ADMIN_AUX,
                RCV,
                SALES_RCV_SCORP,
                SALES_KEY_ACCOUNTS,
                // SALES_COUNTER,
              ]} // Tipos de usuario autorizados a esta ruta
              component={Exportables}
            />
            <ProtectedRoute
              path="/dashboard/inbox"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_ADMIN_AUX,
                SALES_COUNTER,
                SALES_FARMER,
                SALES_HUNTER,
                SALES_KEY_ACCOUNTS,
              ]}
              component={Inbox}
            />
            {/* Modulo de Giftcards */}
            <ProtectedRoute
              path="/admin/consultant-commissions"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX]} // Tipos de usuario autorizados a esta ruta
              component={Comissions}
            />
            <ProtectedRoute
              path="/admin/intermediary-commissions"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX]}
              allow={auth.isAgencyMaster}
              component={IntermediaryComissions}
            />
            <ProtectedRoute
              path="/admin/cashea"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                // Solo Venta
                SALES_ADMIN_AUX,
              ]} // Tipos de usuario autorizados a esta ruta
              component={Cashea}
            />
            <ProtectedRoute
              path="/modules/cashea-link-deleted-orders"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                // Solo Venta
                SALES_ADMIN_AUX,
              ]} // Tipos de usuario autorizados a esta ruta
              component={CasheaLinkDeletedOrders}
            />
            <ProtectedRoute
              path="/admin/changes"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                // Solo Venta
                SALES_ADMIN_AUX,
              ]} // Tipos de usuario autorizados a esta ruta
              component={Changes}
            />
            <ProtectedRoute
              path="/admin/advanced-payments"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_ADMIN_AUX,
                SALES_FARMER,
                SALES_HUNTER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={AdvancedPayments}
            />
            <ProtectedRoute
              path="/modules/potential-clients"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                SALES_COUNTER,
                SALES_FARMER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={PotentialClients}
            />
            <ProtectedRoute
              path="/modules/giftcard-sales"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_MARKETING,
                // Solo Venta
                SALES_ADMIN_AUX,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={Giftcards}
            />
            <ProtectedRoute
              path="/modules/giftcard-codes"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_MARKETING,
              ]} // Tipos de usuario autorizados a esta ruta
              component={GiftcardsCodes}
            />
            <ProtectedRoute
              path="/admin/validate-payments"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_ADMIN_AUX,
              ]} // Tipos de usuario autorizados a esta ruta
              component={ValidatePayments}
            />
            {/* Modulo de Flotas */}
            <ProtectedRoute
              path="/modules/fleet-register/:fleetId/load-detail/:loadId"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_KEY_ACCOUNTS]} // Tipos de usuario autorizados a esta ruta
              component={FleetLoadDetails}
            />
            <ProtectedRoute
              path="/modules/fleet-register/fleet-load-form/:fleetId"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_KEY_ACCOUNTS]} // Tipos de usuario autorizados a esta ruta
              component={FleetLoadForm}
            />
            <ProtectedRoute
              path="/modules/fleet-register/detail/:fleetId"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_KEY_ACCOUNTS]} // Tipos de usuario autorizados a esta ruta
              component={FleetDetail}
            />
            <ProtectedRoute
              path="/modules/fleet-register"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_KEY_ACCOUNTS]} // Tipos de usuario autorizados a esta ruta
              component={FleetRegister}
            />
            {/* Configurations */}
            <ProtectedRoute
              path="/config/exchange-rate"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_HUNTER,
                EVENTS,
                SALES_FARMER,
                SALES_COUNTER,
                SALES_ADMIN_AUX,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={RateDate}
            />
            <ProtectedRoute
              path="/config/parameters"
              level={[
                SALES_DEVELOPER,
                SALES_ADMIN,
                SALES_SUPERVISOR,
                SALES_KEY_ACCOUNTS,
              ]} // Tipos de usuario autorizados a esta ruta
              component={Parameters}
            />
            <ProtectedRoute
              path="/config/update-history"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR]} // Tipos de usuario autorizados a esta ruta
              component={UpdateHistory}
            />
            <ProtectedRoute
              path="/config/users"
              level={[SALES_DEVELOPER, SALES_ADMIN]} // Tipos de usuario autorizados a esta ruta
              component={SalesUsers}
            />
            <ProtectedRoute
              path="/config/discounts"
              level={[SALES_DEVELOPER, SALES_ADMIN]} // Tipos de usuario autorizados a esta ruta
              component={DiscountCode}
            />
            <ProtectedRoute
              path="/config/goals"
              level={[SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX]} // Tipos de usuario autorizados a esta ruta
              component={Goals}
            />

            <Route
              path="/not-found"
              render={(props) => {
                return <PageNotFound {...props} props={props} />;
              }}
            />
            <Route
              path="/cashea-confirmation"
              render={() => {
                return <CasheaRedirect />;
              }}
            />
            <Route
              path="/cashea-checkout"
              render={() => {
                return <CasheaCheckout />;
              }}
            />
            <Route
              path="/"
              render={(props) => {
                return <Landing {...props} props={props} />;
              }}
            />
            <Route component={PageNotFound} />
          </Switch>
        </div>
        {(!isPublicView && isLoggedIn) && (
          <>
            <FloatingCotizadorPlanes />
            <FloatingCalculadoraBCV />
          </>
        )}
      </div>
    </React.Fragment>
  );
}

export default App;
